import React, { useMemo } from 'react';
import cn from 'classnames';
import { ContactAvatar } from '@repo/components/avatars';
import ResourcePermissionsEditor from './ResourcePermissions';
import Contact from '@repo/utils/models/Contact';
import styles from './ShareContact.module.scss';
import { SharedResourceType } from '@repo/redux/reducers/data/shareStatuses';
import { Sharee } from '@repo/utils/models/Sharee';

export default function ShareeRow<P>({
  sharedResourceType,
  sharee,
  addPermission,
  removePermission,
  unshare,
}: {
  sharedResourceType: SharedResourceType;
  sharee: Sharee<P>;
  addPermission: (permission: P) => void;
  removePermission: (permission: P) => void;
  unshare: () => void;
}) {
  const shareeAsContact = useMemo(
    () =>
      new Contact({ displayName: sharee.displayName || sharee.email, avatarURL: sharee.avatarURL }),
    [sharee],
  );
  const shouldRenderDisplayName =
    !!sharee.displayName && sharee.displayName.toLowerCase() != sharee.email?.toLowerCase();

  return (
    <>
      <div className={styles.avatarContainer}>
        <ContactAvatar
          className={styles.fallbackAvatar}
          contact={{ ...shareeAsContact, avatarURL: null }}
          size="sm"
        />
        {shareeAsContact.avatarURL && (
          <ContactAvatar className={styles.contactAvatar} contact={shareeAsContact} size="sm" />
        )}
      </div>
      <div className={styles.shareeLabel}>
        {sharee.email}{' '}
        {shouldRenderDisplayName && (
          <span className={cn(styles.contactName, 'information')}>({sharee.displayName})</span>
        )}
      </div>
      <ResourcePermissionsEditor
        sharedResourceType={sharedResourceType}
        permissions={sharee.permissionsMap}
        addPermission={addPermission}
        removePermission={removePermission}
        unshare={unshare}
      />
    </>
  );
}
